import React from "react";

import logo from "../assets/logo_large.png";

const Hero = () => (
  <div className="text-center hero my-2">
    <img className="mb-3 app-logo" src={logo} alt="React logo" width="120" />
    <h1 className="mb-2">Exotic Car Trader Creators</h1>

  </div>
);

export default Hero;
